const $ = require("jquery");

window.jQuery = $;
window.$ = $;

window.bootstrap = require('../../../vendor/bootstrap5');

import swal from "sweetalert2";
window.swal = swal;

window.toastr = require('toastr');
window.axios = require('axios');

require("popper.js");

/////JQUERY-UI/////
// require('jquery-ui'); // Cette ligne ne charge rien du tout...
// Il faut charger les widget un par un
import "jquery-ui/ui/widgets/autocomplete.js";


//Import here the specific librairies for backoffice
import "jquery-validation/dist/localization/messages_fr.js";
require("jquery-ui");

require("../../../vendor/jquery-form/jquery.form");

require("../../../vendor/hegyd/core/js/hegyd-core");

require("../../../vendor/hegyd/core/dependencies/switchery/dist/switchery.js");

require("../../../vendor/hegyd/newsletters/js/modal_subscription");
require("../../../vendor/hegyd/newsletters/js/subscription_newsletters");

import TarteAuCitron from "../components/TarteAuCitron";
customElements.define("tarte-au-citron", TarteAuCitron);

import CommunicationModal from "../components/CommunicationModal";
customElements.define("communication-modal", CommunicationModal);

import EtrennesModal from "../components/EtrennesModal";
customElements.define("etrennes-modal", EtrennesModal);

import EstimationModal from "../components/EstimationModal.js";
customElements.define("ope-estimation-modal", EstimationModal);
